import { useState } from 'react';
import { deleteJobCost } from '../api/jobCosts';

/**
 * Hook for deleting a job cost
 */
export function useDeleteJobCost() {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteCost = async (jobId: number, costId: number): Promise<boolean> => {
    setIsDeleting(true);
    setError(null);
    try {
      await deleteJobCost(jobId, costId);
      return true;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to delete job cost');
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    deleteCost,
    isDeleting,
    error,
  };
}
